import {
  BrowserRouter,
  Routes,
  Route,
  Navigate
} from "react-router-dom";

import ProtectedRoute from "./ProtectedRoute";
import Layout from "../components/Layout";
import Login from "../pages/Login";
import Dashboard from "../pages/Dashboard";
import Vendors from "../pages/vendor/Vendors";
import ZonalAdmins from "../pages/ZonalAdmin/ZonalAdmins";
import VendorDetails from "../pages/vendor/VendorDetails";
import DeliveryBoys from "../pages/ZonalDeliveryBoy/DeliveryBoys";
import BatchPage from "../pages/BatchModel/BatchPage";
import BatchDetails from "../pages/BatchModel/BatchDetails";
import Coupons from "../components/Coupons";
import FoodTags from "../components/FoodTags";
import CityRiders from "../pages/CityAdminRiders/CityRiders";

// 👇 NEW IMPORTS FOR CITY ADMIN HIERARCHY
import ZonalAdminHub from "../pages/ZonalAdmin/ZonalAdminHub";
import RiderProfile from "../pages/CityAdminRiders/RiderProfile";
import ZonalAdminFinance from "../pages/ZonalAdmin/ZonalAdminFinance";

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>

        {/* PUBLIC ROUTES (Maps both / and /login to Login component) */}
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />

        {/* PROTECTED ROUTES */}
        <Route
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          {/* COMMON & ZONAL ADMIN BASE ROUTES (Kept exactly as they were) */}
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/vendors" element={<Vendors />} />
          <Route path="/vendors/:id" element={<VendorDetails />} />
          <Route path="/delivery-boys" element={<DeliveryBoys />} />
          <Route path="/batches" element={<BatchPage />} />
          <Route path="/batches/:id" element={<BatchDetails />} />
          <Route path="/coupons" element={<Coupons />} />
          <Route path="/tags" element={<FoodTags />} />
          <Route path="/riders" element={<CityRiders />} />

          {/* 🏙️ CITY ADMIN HIERARCHICAL ROUTES */}
          <Route path="/zonal-admins" element={<ZonalAdmins />} />
          <Route path="/zonal-admins/:id" element={<ZonalAdminHub />} />
          <Route path="/zonal-admins/:id/vendors" element={<Vendors />} />
          <Route path="/zonal-admins/:id/riders" element={<CityRiders />} />
          <Route path="/zonal-admins/:id/riders/:riderId" element={<RiderProfile />} />
          <Route path="/zonal-admins/:id/tags" element={<FoodTags />} />
          <Route path="/zonal-admins/:id/coupons" element={<Coupons />} />
          <Route path="/zonal-admins/:id/finance" element={<ZonalAdminFinance />} />
        </Route>

        {/* CATCH-ALL ROUTE: Redirects any unknown/invalid URLs back to login */}
        <Route path="*" element={<Navigate to="/login" replace />} />

      </Routes>
    </BrowserRouter>
  );
}